import React from "react"
import { Container } from "@inlet/react-pixi"
import Rect from "components/rect"
import Shadow from "components/shadow"

const Overlay = () => {
  return (
    <></>
    /*<Shadow>
      <Container alpha={0.5}>
        <Rect x={120} y={120} width={60} height={60} color={0x000000} />
        <Rect x={180} y={120} width={60} height={60} color={0x000000} />
      </Container>
    </Shadow>*/
  )
}

export default Overlay
